import { Map as ImmutableMap } from 'immutable';
import { FetchHubUsersActionTypes } from '../actions/HubUsersActions';
import HubUser from '../records/HubUser';
import { handleActions } from 'flux-actions';
const initialState = ImmutableMap();
export default handleActions({
  [FetchHubUsersActionTypes.SUCCESS](state, action) {
    return state.withMutations(map => {
      action.payload.data.forEach(hubUser => {
        map.set(hubUser.id, new HubUser(hubUser));
      });
    });
  }
}, initialState);